(function (jQuery, undefined){
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal : {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm : {} });
    }
    
    // PRIMARY CONTAINER - Student 360 Profile View Model
    function Student360ViewModel(){
        var self = this;
        
        // Model Loading Methods
        this.TemplatesLoaded = ko.observable();

        this.showAcademicRecord = ko.observable(true);
        this.ShowBilling = ko.observable(true);
        this.ShowCommunications = ko.observable(true);
        this.ShowEnrolments = ko.observable(true);
        this.ShowFinantialAid = ko.observable(true);
        this.ShowMessages = ko.observable(true);
        this.ShowProfile = ko.observable(true);
        
        sm.portal.vm.custom.setCustomLocalizeKey(self);
        
        sm.portal.vm.custom.callCustomization('UpdatePropsforStudent360', self);
        
        this.LoadProfileModel = function (container){
            var newProfileModel = new sm.portal.widget.StudentProfileViewModel();
            newProfileModel.LoadModel(container);
            this.Profile(newProfileModel);
        };

        this.LoadMessagesModel = function (container){
            var newMessagesModel = new sm.portal.common.widget.MessagesViewModel();
            newMessagesModel.LoadModel(container);
            this.Messages(newMessagesModel);
        };

        this.LoadBillingSummaryModel = function (container){
            var newBillingSummaryModel = new sm.portal.widget.StudentBillingSummaryViewModel();
            newBillingSummaryModel.LoadModel(container);
            this.BillingSummary(newBillingSummaryModel);
        };

        this.LoadCoursesModel = function (container){
            var newEnrollmentModel = new sm.portal.widget.StudentEnrollmentViewModel();
            newEnrollmentModel.LoadModel(container);
            this.Courses(newEnrollmentModel);
        };

        this.LoadAcademicRecordModel = function (container) {
            var newAcademicRecordModel = new sm.portal.widget.StudentAcademicRecordViewModel();
            newAcademicRecordModel.LoadModel(container);
            this.AcademicRecords(newAcademicRecordModel);
        };

        this.LoadFinancialAidModel = function (container){
            var newFinAidSummaryModel = new sm.portal.widget.FinancialAidSummaryViewModel();
            newFinAidSummaryModel.LoadModel(container);
            this.FinancialAidSummary(newFinAidSummaryModel);
        };

        this.LoadCommunicationModel = function (container){
            var newInbox = new sm.portal.widget.InboxViewModel();
            newInbox.LoadModel(container);
            this.Communications(newInbox);
        };

        // Role Properties (TODO: Flesh this out in the process, trying to bring role-based templates into the Portal architecture.
        this.CurrentUserRole = ko.observable("Default");
        this.TemplateName = function (requestedTemplate){
            return sm.portal.utility.formatString(requestedTemplate, this.CurrentUserRole());
        };

        // Standard Methods
        this.HandleError = function (title, messages){
            this.IsError(true);
            this.ErrorMessages(messages);
            if (sm.portal.utility.isNullOrEmpty(title)) {
                viewModel.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            }
            else {
                viewModel.ErrorHeader(title);
            }
        };
        this.LoadInitialData = function (){
            if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization("AllDataFlag"))){
                this.LoadAcademicRecordSection(); // Do this first, "marked" SAR should load the rest
    
                this.LoadProfileSection();
                this.LoadMessagesSection();
                this.LoadBillingSection();
                this.LoadCoursesSection();
                this.LoadFinancialAidSection();
                this.LoadCommunicationSection();
                
                // TODO: Academic Record VM Initialization
            } else {
                this.GetAllSectionData();
            }

        };

        // Loading Methods
        this.AcademicRecordSectionLoaded = ko.observable();

        this.ProfileSectionLoaded = ko.observable();
        this.MessagesSectionLoaded = ko.observable();
        this.BillingSectionLoaded = ko.observable();
        this.FinancialAidSectionLoaded = ko.observable();
        this.CommunicationSectionLoaded = ko.observable();
        this.CoursesSectionLoaded = ko.observable();

        this.GetAllSectionData = function(){
            var url = _baseApiUri + '/api/student360/GetProfileAllSections/?studentid=&goalId=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.CompositePayload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {
                        var newData = self.constructAllData(container.Payload);
                        self.LoadAcademicRecordModel(newData.academicrecordSection);
                        self.AcademicRecordSectionLoaded(true);

                        self.LoadMessagesModel(newData.messagesSection);
                        self.MessagesSectionLoaded(true);

                        self.LoadProfileModel(newData.profileSection);
                        self.ProfileSectionLoaded(true);
                        
                        self.LoadBillingSummaryModel(newData.billingSection);
                        self.BillingSectionLoaded(true);

                        self.LoadCoursesModel(newData.coursesSection);
                        self.CoursesSectionLoaded(true);

                        self.LoadFinancialAidModel(newData.financialaidSection);
                        self.FinancialAidSectionLoaded(true);

                        self.LoadCommunicationModel(newData.communicationSection);
                        self.CommunicationSectionLoaded(true);     
                        jQuery('#sm360Communications').find('iframe').each(function () {
                            if (!jQuery(this).contents().find('a,area,input,select,textarea,button').length > 0) {
                                jQuery(this).attr('tabindex', '-1');
                            }
                        })

                    }
                    else if (data.Status === 'validationerror') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.Profile().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.Profile().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){
                    if (jqXHR.status == 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                        if (jqXHR != null && jqXHR.responseText != null) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);

                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        }
        this.constructAllData = function (container) {
            var obj = {};
            for (const [key, value] of Object.entries(container)) {
                obj[key] = {};
                obj[key].Payload = value;
            }
            return obj;
        }

        // Loaded Flags
        this.LoadProfileSection = function (){
            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=profile&studentid=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {

                        self.LoadProfileModel(container);
                        self.ProfileSectionLoaded(true);

                    }
                    else if (data.Status === 'validationerror') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.Profile().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.Profile().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){
                    if (jqXHR.status == 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                        if (jqXHR != null && jqXHR.responseText != null) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);

                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        };

        this.LoadMessagesSection = function (){

            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=messages&studentid=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {
                        self.LoadMessagesModel(container);
                        self.MessagesSectionLoaded(true);

                    }
                    else if (data.Status === 'validationerror') {
                        self.IsError(true);
                        self.Messages().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {
                        self.IsError(true);
                        self.Messages().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){

                    if (jqXHR.status === 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                        if (jqXHR != null && jqXHR.responseText != null) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        };

        this.LoadBillingSection = function (){
            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=billing&studentid=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {

                        self.LoadBillingSummaryModel(container);
                        self.BillingSectionLoaded(true);

                    }
                    else if (data.Status === 'validationerror') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.BillingSummary().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.BillingSummary().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){

                    if (jqXHR.status === 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                        if (jqXHR != null && jqXHR.responseText != null) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        };
        this.LoadCoursesSection = function (){
            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=courses&studentid=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {

                        self.LoadCoursesModel(container);
                        self.CoursesSectionLoaded(true);

                    }
                    else if (data.Status === 'validationerror') {

                        self.IsError(true);
                        self.Courses().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        self.IsError(true);
                        self.Courses().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){

                    if (jqXHR.status === 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                        if (jqXHR != null && jqXHR.responseText != null) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        };
        this.LoadFinancialAidSection = function (){
            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=financialaid&studentid=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {

                        self.LoadFinancialAidModel(container);
                        self.FinancialAidSectionLoaded(true);

                    }
                    else if (data.Status === 'validationerror') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.FinancialAidSummary().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.FinancialAidSummary().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){

                    if (jqXHR.status == 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {
                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');

                        if (jqXHR != null && !sm.portal.utility.isNullOrEmpty(jqXHR.responseText)) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        };
        this.LoadCommunicationSection = function (){
            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=communication&studentid=';
            jQuery.ajax({
                url : url,
                type : 'GET',
                dataType : 'json',
                contentType : 'application/json; charset=utf-8',
                headers : {
                    "x-api-version" : '1' //,
                },
                processData : false,
                crossDomain : true,

                xhrFields : {
                    withCredentials : true
                },
                success : function (data, textStatus, jqXHR){
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {

                        self.LoadCommunicationModel(container);
                        self.CommunicationSectionLoaded(true);        
                        jQuery('#sm360Communications').find('iframe').each(function () {
                            if (!jQuery(this).contents().find('a,area,input,select,textarea,button').length > 0) {
                                jQuery(this).attr('tabindex', '-1');
                            }
                        })
                    }
                    else if (data.Status === 'validationerror') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.Communications().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        //self.HandleError(container.ValidationTitle, container.ValidationMessages);
                        self.IsError(true);
                        self.Communications().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error : function (jqXHR, exception){

                    if (jqXHR.status == 401) {
                        var title = sm.portal.utility.getResourceValue('UnAuthorized');
                        var body = sm.portal.utility.getResourceValue('NotAuthorizedToViewPage');
                        self.HandleError(title, [body]);
                        self.IsAuthorized(false);
                    }
                    else {

                        var statusText = jqXHR.statusText;
                        var responseMsg = sm.portal.utility.getResourceValue('UnknownError');

                        if (jqXHR != null && !sm.portal.utility.isNullOrEmpty(jqXHR.responseText)) {
                            responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                        }
                        var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                        self.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    }
                }
            });
        };

        // TODO: Academic Record VM Initialization
        this.LoadAcademicRecordSection = function () {
            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=academicrecord&studentid=';
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status,
                        data.Payload,
                        data.ValidationTitle,
                        data.ValidationMessages);

                    if (data.Status === 'success') {

                        self.LoadAcademicRecordModel(container);
                        self.AcademicRecordSectionLoaded(true);

                    }
                    else if (data.Status === 'validationerror') {

                        self.IsError(true);
                        self.AcademicRecords().HandleError(container.ValidationTitle, container.ValidationMessages);

                    }
                    else if (data.Status === 'error') {

                        self.IsError(true);
                        self.AcademicRecords().HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                    sm.portal.ui.readyPage();
                },
                error: function (jqXHR, exception) {

                    var statusText = jqXHR.statusText;
                    var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                    if (jqXHR != null && jqXHR.responseText != null) {
                        responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                    }
                    var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                    try {
                        viewModel.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    } catch (e) { }
                }
            });
        };

        // Error Handling
        this.ErrorHeader = ko.observable();
        this.ErrorMessages = ko.observableArray();
        this.IsError = ko.observable(false);
        this.IsAuthorized = ko.observable(true);

        // START Profile Section Data
        this.Profile = ko.observable(new sm.portal.widget.StudentProfileViewModel());
        // END Profile Section Data

        // START Messages & Alerts Section Data
        this.Messages = ko.observable(new sm.portal.common.widget.MessagesViewModel());
        // END Messages & Alerts Section Data

        // START BillingSummary Section Data
        this.BillingSummary = ko.observable(new sm.portal.widget.StudentBillingSummaryViewModel());
        // END BillingSummary Section Data

        // START Courses Section Data
        this.Courses = ko.observable(new sm.portal.widget.StudentEnrollmentViewModel());
        // END Courses Section Data

        // START Financial Aid Section Data
        this.FinancialAidSummary = ko.observable(new sm.portal.widget.FinancialAidSummaryViewModel());
        // END Financial Aid Section Data

        // START Communication Section Data
        this.Communications = ko.observable(new sm.portal.widget.InboxViewModel());
        // END Communication Section Data

        // START Courses Section Data
        this.AcademicRecords = ko.observable(new sm.portal.widget.StudentAcademicRecordViewModel());
        // END Courses Section Data
        
        return self;
    }

    jQuery.extend(true,
        sm.portal.vm,
        {
            Student360ViewModel : Student360ViewModel
        });


    // Student Academic Record Widget View Model
    // Added here to avoid additional shortcodes in the page content
    //  Array Model
    function StudentAcademicRecordViewModel() {

        // Array List
        this.DataList = ko.observableArray();

        // List Item and List Detail Items
        this.DataSubItem = function () {
            this.Goal = ko.observable();
            this.Program = ko.observable();
            this.IsPrimary = ko.observable(false);
        };

        this.DataItem = function () {
            this.ID = ko.observable();
            this.GID = ko.observable();
            this.Title = ko.observable();
            this.ViewOnPortal = ko.observable();
            this.Goals = ko.observableArray();            
            var dataItemSelf = this;
            this.ViewOnPortal.subscribe(function (newValue) {
                // The subscribe ensures the cookie gets set/updated regardless of what changes the value
                if (newValue == true) {
                    sm.portal.ui.setSessionCookie("_ViewOnPortal", dataItemSelf.GID());
                }
            });
        };

        

        // Loading
        this.LoadModel = function (container) {

            var list = container.Payload.AcademicRecords;

            // Clear existing data
            this.DataList.removeAll();

            
            if (!sm.portal.utility.isNullOrEmpty(list)) {

                // Retrieve existing cookie value in case it's already been set
                var existingCookieValue = sm.portal.ui.getCookie("_ViewOnPortal");
                var hadCookieAlready = !sm.portal.utility.isNullOrEmpty(existingCookieValue);

                // Create DataItems for each result and add to DataList
                for (var i = 0; i < list.length; i++) {

                    var listItem = list[i];
                    var record = new this.DataItem();

                    record.ID(listItem.ID);
                    record.GID(listItem.GID);
                    record.Title(listItem.Title);

                    for (var j = 0; j < listItem.Goals.length; j++) {
                        var listSubItem = listItem.Goals[j];
                        var subRecord = new this.DataSubItem();
                        subRecord.Goal(listSubItem.Goal);
                        subRecord.Program(listSubItem.Program);
                        subRecord.IsPrimary(listSubItem.IsPrimary);

                        record.Goals.push(subRecord);
                    }
                    this.DataList.push(record);
                }

                var newEl;
                var firstEl;
                for (var j = 0; j < this.DataList().length; j++) {
                    this.DataList()[j].ViewOnPortal(false);
                    if (hadCookieAlready && this.DataList()[j].GID() == existingCookieValue) {
                        newEl = this.DataList()[j];
                    }
                    if (j == 0) {
                        firstEl = this.DataList()[j];
                    }
                }

                if (hadCookieAlready && newEl) {
                    newEl.ViewOnPortal(true);
                } else if (firstEl) {
                    firstEl.ViewOnPortal(true);
                }
            }
            this.Loaded(true);
        };
        this.Loaded = ko.observable(false);

        // Mark As View trigger
        this.MarkAsViewRecord = function (el) {
            var id = el.ID();

            if (!sm.portal.utility.isNullOrEmpty(id)) {
                for (var i = 0; i < self.DataList().length; i++) {
                    self.DataList()[i].ViewOnPortal(false);
                }
                el.ViewOnPortal(true);
            }
        };


        this.IsError = ko.observable(false);
        this.ErrorHeader = ko.observable();
        this.ErrorMessages = ko.observableArray();
        this.HandleError = function (header, msgs) {
            this.IsError(true);
            this.ErrorMessages(msgs);
            if (sm.portal.utility.isNullOrEmpty(header)) {
                this.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            } else {
                this.ErrorHeader(header);
            }
        };

        // Data Retrieval (NOTE: this could be handled via the parent view model, but this is here as a stand-alone)
        this.GetModelData = function (studentID, goalID) {

            var url = _baseApiUri + 'api/student360/getprofilesection/?sec=academicrecord&studentid=' + studentID;
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);

                    if (data.Status == 'success') {
                        self.LoadModel(container);
                    }
                    sm.portal.ui.readyPage();
                },
                error: function (jqXHR, exception) {

                    var statusText = jqXHR.statusText;
                    var responseMsg = sm.portal.utility.getResourceValue('UnknownError');
                    if (jqXHR != null && jqXHR.responseText != null) {
                        responseMsg = jQuery.parseJSON(jqXHR.responseText).Message;
                    }
                    var messageToUser = sm.portal.utility.formatString("{0} - {1}", statusText, responseMsg);
                    try {
                        viewModel.HandleError(sm.portal.utility.getResourceValue('ErrorAccessingPage'), [messageToUser]);
                    } catch (e) { }
                }
            });
        };

        var self = this;
        return self;
    };    

    if (typeof sm.portal.widget === "undefined") {
        jQuery.extend(sm.portal, { widget: {} });
    }

    jQuery.extend(true, sm.portal.widget, {
        StudentAcademicRecordViewModel: StudentAcademicRecordViewModel
    });
})(jQuery);